/**
 * Response item returned from the live list API.
 */
export class LiveListOption {
	label = '';

	value = '';

	metadata = null;

	disabled = false;

	constructor({
		label = '',
		value = '',
		metadata = null,
		disabled = false,
	} = {}) {
		this.label = label;
		this.value = value;
		this.metadata = metadata;
		this.disabled = disabled;
	}
}
